import { observer } from "mobx-react";
import React from "react";
import { Legend, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar} from "recharts";
import adminStore from "../../stores/adminStore";

class CustomTick extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { x, y, index, payload } = this.props;

        let name = []
        let idx = 0
        const toks = payload.value.split(' ')
        toks.forEach((v, i) => {
            if (i === 0) {
                name.push(v)
                return
            }
            if (v.length < 3) {
                name[idx] += ' ' + v
            } else {
                name.push(v)
                idx++
            }
        })
        const fontColors =  [ "#666", "#0084c1" ]

        return (
            <g transform={`translate(${x},${y})`}>
                <text x={0} y={0} dy={16} textAnchor="end" fill={fontColors[index % 2]} transform="rotate(-60)">
                    { name.map((v, i) => {
                        const y = i === 0 ? 0 : 25 + ((i - 1) * 9)
                        return <tspan style={{fontSize: "0.7em"}} x={-10} y={y-(name.length/2)*15}>{v}</tspan>
                    })}
                </text>
            </g>
        );
    }

}

@observer
class FinishedPolls extends React.Component {
    constructor(props) {
        super(props)
        this.state = { currentArea: undefined }
    }

    componentDidMount() {
        this.setState({ currentArea: adminStore.dashboard.finished_polls.areas[0] })
    }

    render() {
        const { dashboard } = adminStore;
        if (!dashboard.finished_polls) {
            return <div></div>;
        }

        const colors = [ "#eeaa7b", "#66b9bf" ];
        const { areas, finished, total, byArea, byCharge, byAreaByCharge } = dashboard.finished_polls
        const { currentArea } = this.state

        const width = (window.innerWidth - 240 - 100)
        const height = 500

        return (
            <div>
                <div>
                    <h2>Total de Encuestas Terminadas {finished} de {total}</h2>
                </div>
                <br />
                <div>
                    <h4>Por Area</h4>
                    { byArea && byArea.length > 0 &&
                    <BarChart width={width} height={height} data={byArea} margin={{bottom: 100}}>
                        <CartesianGrid y={10} />
                        <XAxis dataKey="name" interval={0} tick={<CustomTick />} />
                        <YAxis />
                        <Tooltip />
                        <Legend verticalAlign='top' />
                        <Bar key={`bar-finished`} stackId={"a"} dataKey={'Terminadas'} fill={colors[0]} />
                        <Bar key={`bar-unfinished`} stackId={"a"} dataKey={'Sin Terminar'} fill={colors[1]} />
                    </BarChart>
                    }
                </div>
                <br />
                <div>
                    <h4>Por Cargo</h4>
                    { byCharge && byCharge.length > 0 &&
                    <BarChart width={width} height={height} data={byCharge} margin={{bottom: 100}}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" interval={0} tick={<CustomTick />} />
                        <YAxis />
                        <Tooltip />
                        <Legend verticalAlign='top' />
                        <Bar key={`bar-finished`} stackId={'a'} dataKey={'Terminadas'} fill={colors[0]} />
                        <Bar key={`bar-unfinished`} stackId={'a'} dataKey={'Sin Terminar'} fill={colors[1]} />
                    </BarChart>
                    }
                </div>
                <br />
                <div>
                    <h4>Por Area y Cargo</h4>
                    { byAreaByCharge && byAreaByCharge.length > 0 &&
                    <select
                        className="form-select"
                        id="inputArea"
                        aria-label="Selecciona el Area para ver los resultados por Cargo"
                        onChange={({target}) => this.setState({currentArea: target.value})}
                        value={currentArea}
                    >
                        <option key={""} value="" className="selected">
                            Selecciona el Area para ver los resultados por Cargo
                        </option>
                        {areas.map((a) => <option key={a} value={a}> {a} </option> )}
                    </select>
                    }
                    <br />

                    {currentArea in byAreaByCharge &&
                        <BarChart width={width} height={height} data={byAreaByCharge[currentArea]} margin={{bottom: 100}}>
                        <CartesianGrid strokeDasharray="3 3"/>
                        <XAxis dataKey="name" interval={0} tick={<CustomTick />} />
                        <YAxis/>
                        <Tooltip/>
                        <Legend verticalAlign='top' />
                        <Bar key={`bar-finished`} stackId={"x"} dataKey={'Terminadas'} fill={colors[0]}/>
                        <Bar key={`bar-unfinished`} stackId={"x"} dataKey={'Sin Terminar'} fill={colors[1]}/>
                        </BarChart>
                    }
                </div>
            </div>
        );
    }
}

export { FinishedPolls, CustomTick };

